export default class TrainingResearchListCtrl {

  constructor ($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig, Requests, $sessionStorage) {
    var trainingResearchVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }
    //Variables
    trainingResearchVm.viewLoaded = false
    trainingResearchVm.active = GlobalConfig.generals.active
    trainingResearchVm.notActive = GlobalConfig.generals.notActive
    trainingResearchVm.planningFinish = true
    $scope.classPlanning = ''
    trainingResearchVm.feedback = 0
  	trainingResearchVm.trainings = []
    trainingResearchVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
    
    //Methods
    trainingResearchVm.updateView = updateView
    trainingResearchVm.gradRoleClass = 'grad-5'
    trainingResearchVm.confirmDeleteTraining = confirmDeleteTraining
    trainingResearchVm.getGeneralsWorkplan = getGeneralsWorkplan
    trainingResearchVm.bitacora = bitacora
    trainingResearchVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    trainingResearchVm.$sessionStorage = $sessionStorage

    trainingResearchVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]

    active()

    function active(){
      if(trainingResearchVm.workPlanGeneralList != undefined){
        trainingResearchVm.status = trainingResearchVm.workPlanGeneralList.wokplanTeacherStatus[0]
        trainingResearchVm.stages = trainingResearchVm.workPlanGeneralList.stages
        trainingResearchVm.inReview = trainingResearchVm.status.reviewed
        trainingResearchVm.feedback = trainingResearchVm.status.feedbackReviewed
        trainingResearchVm.workplanTeacherId = trainingResearchVm.status.workplanTeacherId
        isPlanning(trainingResearchVm.status, trainingResearchVm.stages)
        
        if(trainingResearchVm.feedback && !trainingResearchVm.planningFinish){
          getListResearchTrainingReject()
        }else{
          getListResearchTraining()
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(trainingResearchVm.feedback && !trainingResearchVm.planningFinish){
            getListResearchTrainingReject()
          }else{
            getListResearchTraining()
          }
        })
      }

      updateView()
    }

    function getListResearchTraining(){
      WorkPlanSrv.getListResearchTraining.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            trainingResearchVm.trainings = dataReturn.listResearchTraining
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function getListResearchTrainingReject(){
      WorkPlanSrv.getListResearchTrainingReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            trainingResearchVm.trainings = dataReturn.listResearchTraining
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function updateView () {
      trainingResearchVm.viewLoaded = false
      $timeout(() => {
        trainingResearchVm.viewLoaded = true
      }, 1)
    }

    function confirmDeleteTraining (item) {
      let trainingName = item.nameResearch
      let workplanTeacherActivityId = item.workplanTeacherActivityId
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.trainingName = trainingName
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.delete = function () {
            WorkPlanSrv.disableActivityResearch.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                removeSpaceFromCaroussel(item)
                showDeletedSuccessfully(ctrlModalVM.trainingName)
                WorkPlanIndicatorSrv.setVariable(true)
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {
              
            })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteTrainingResearchModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedSuccessfully(trainingName){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : trainingName,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })      
    }

    function removeSpaceFromCaroussel(item){
      for(var i in trainingResearchVm.trainings){
        if(trainingResearchVm.trainings[i].workplanTeacherActivityId === item.workplanTeacherActivityId){
          trainingResearchVm.trainings.splice(i,1)
          updateView()
          break
        }
      }
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          trainingResearchVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          trainingResearchVm.status = dataReturn.data.wokplanTeacherStatus[0]
          trainingResearchVm.stages = dataReturn.data.stages
          trainingResearchVm.inReview = trainingResearchVm.status.reviewed
          trainingResearchVm.feedback = trainingResearchVm.status.feedbackReviewed
          trainingResearchVm.workplanTeacherId = trainingResearchVm.status.workplanTeacherId
          isPlanning(trainingResearchVm.status, trainingResearchVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      trainingResearchVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          trainingResearchVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == trainingResearchVm.active) {
          trainingResearchVm.planningFinish = true
          if (trainingResearchVm.startDateReview < trainingResearchVm.currentDate || status.reviewedFinish == trainingResearchVm.active) {
            trainingResearchVm.planningFinish = true
          } else if (status.reviewedReject == trainingResearchVm.active) {
            trainingResearchVm.planningFinish = false
          }
        } else {
          trainingResearchVm.planningFinish = false
        }
      }else{
        trainingResearchVm.planningFinish = true
      }

      $scope.classPlanning = (trainingResearchVm.planningFinish ? "disabled" : " ")
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.investigation,
        workplanTeacherId: trainingResearchVm.workplanTeacherId
      }
      entries.title = 'Formación en investigación'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }
}
TrainingResearchListCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig', 'Requests', '$sessionStorage'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/trainingResearch/list/trainingResearchListCtrl.js